import React from 'react';
import { api } from '../api';
import { fmt } from '../utils';

export default function CapitalPartnerSection({ deal, onUpdate }) {
  const save = async (field, value) => {
    await api.updateDeal(deal.id, { [field]: value });
    onUpdate();
  };

  const Field = ({ label, field, type = 'text', placeholder }) => (
    <div>
      <label>{label}</label>
      <input
        type={type}
        defaultValue={deal[field] ?? ''}
        placeholder={placeholder}
        onBlur={e => {
          const v = type === 'number' ? parseFloat(e.target.value) || null : e.target.value || null;
          if (v !== deal[field]) save(field, v);
        }}
      />
    </div>
  );

  return (
    <div className="card deal-section">
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:16}}>
        <div className="section-title" style={{margin:0}}>Capital Partner</div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={!!deal.has_partner}
            onChange={e => save('has_partner', e.target.checked ? 1 : 0)}
          />
          <span style={{fontSize:12,color:'var(--text-muted)'}}>
            {deal.has_partner ? 'Enabled' : 'Disabled'}
          </span>
        </label>
      </div>

      {!!deal.has_partner && (
        <div className="form-grid">
          <Field label="Partner Name" field="cp_name" />
          <div>
            <label>Contribution Type</label>
            <select defaultValue={deal.cp_contribution_type || 'dollar'}
              onBlur={e => save('cp_contribution_type', e.target.value)}>
              <option value="dollar">Dollar amount</option>
              <option value="pct">% of purchase</option>
            </select>
          </div>
          <Field label={deal.cp_contribution_type === 'pct' ? 'Contribution (%)' : 'Contribution ($)'}
            field="cp_contribution" type="number" />
          <div>
            <label>Return Structure</label>
            <select defaultValue={deal.cp_return_type || 'pct_profit'}
              onBlur={e => save('cp_return_type', e.target.value)}>
              <option value="flat">Flat fee</option>
              <option value="pct_profit">% of profit</option>
              <option value="preferred_return">Preferred return %</option>
            </select>
          </div>
          <Field label={
            deal.cp_return_type === 'flat' ? 'Return Amount ($)' :
            deal.cp_return_type === 'preferred_return' ? 'Preferred Return (%)' :
            'Return (% of profit)'
          } field="cp_return_value" type="number" />
        </div>
      )}
    </div>
  );
}
